module.exports = __webpack_public_path__ + "media/couriers/fedex_logo-29de6a54.png";